import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import history from 'config/history';

import WithOpenModal from 'shared/HOCs/WithOpenModal';
import WithVendorCount from 'shared/HOCs/WithVendorCount';

import {
  MODALS,
  DASHBOARD_URL,
  CREATE_SERVICE_PROVIDER_URL
} from 'global-constants';
import Button from 'shared/components/Button';
import BackStep from 'shared/components/BackStep';
import { previousStep } from 'shared/components/Signup/ducks';
import { getFinalStepText } from 'shared/components/Signup/utils';

import { buildUrlFromNextRedirect } from 'shared/utils/buildUrlFromNext';

import styles from './styles.module.scss';

class AddService extends Component {
  closeActions = () => {
    this.props.closeModal();
    const nextURL = buildUrlFromNextRedirect(history.location.search);

    if (nextURL) {
      this.props.push(nextURL);
      return;
    }

    this.props.push(DASHBOARD_URL);
    this.props.openModal({ modalName: MODALS.POST_SIGNUP });
  };

  render() {
    const { previousStep } = this.props;

    const finalStepText = getFinalStepText({
      defaultText: 'No, go to my Dashboard'
    });

    return (
      <div className={styles.addServiceWrapper}>
        <div>
          <BackStep onClickEvent={previousStep} />
          <div className={classnames('secondary-page-title', styles.pageTitle)}>
            Would you like to list your Service on Unissu?{' '}
          </div>
          <div className={styles.label}>
            You can add your company to Unissu Service Provider database and
            connect with over {this.props.vendorCount} PropTech companies. We’ll
            ask you some general details, and a case study. Don’t worry, you can
            come back and finish the case study at a later time if you don’t
            have the details now.{' '}
          </div>
        </div>
        <div className={styles.btnAndSkipStepWrapper}>
          <Button
            className={styles.completeProfileBtn}
            color="primary"
            onClick={() => {
              this.props.closeModal();
              this.props.push(CREATE_SERVICE_PROVIDER_URL);
            }}>
            Yes, add Company to Unissu
          </Button>
          <div className={styles.dashboardLink} onClick={this.closeActions}>
            {finalStepText}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = { previousStep, push };

export default WithOpenModal(
  WithVendorCount(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(AddService)
  )
);
